import React, { Fragment } from "react";

import { Dialog, Transition } from "@headlessui/react";
import PhoneInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

import { Link } from "react-router-dom";

import Sidebardata from "../home/Sideebar";
import Header from "../home/header";
import Hero from "./HeroViewProduct";
import Loading from "../../Website/Loading";
import UniversalDataTable from "../Contacts/UniversalDataTable";
import Config from "../../utils/Config";

import { useNavigate } from "react-router-dom";

import swal from "sweetalert";

import { useSelector } from "react-redux";

//import LoadingOverlay from 'react-loading-overlay-ts';

export default function ViewInverterProducts() {
  const [ contacts, setContacts ] = React.useState([]);
  const [ page, setPage ] = React.useState(1);
  const [ lastPage, setLastPage ] = React.useState(1);
  const [ currentPage, setCurrentPage ] = React.useState(1);

  const [ contact, setContact ] = React.useState(null);
  
  const [ inverter_product_name, set_inverter_product_name ] = React.useState("ISP27");
  const [ inverter_product_manufacturer, set_inverter_product_manufacturer ] = React.useState("BoxPower");
  const [ inverter_product_part_number, set_inverter_product_part_number ] = React.useState("ISP27");
  const [ inverter_product_certifications, set_inverter_product_certifications ] = React.useState("UL1741");

  const [ inverter_product_unit_capacity, set_inverter_product_unit_capacity ] = React.useState(27.2);
  const [ inverter_product_unit_cost, set_inverter_product_unit_cost ] = React.useState(28793);
  const [ inverter_product_notes, set_inverter_product_notes ] = React.useState("Single phase system with 4 schneider conext pro");
  const [ inverter_product_model, set_inverter_product_model ] = React.useState("ISP27");
  const [ inverter_product_output_power, set_inverter_product_output_power ] = React.useState(27200);
  const [ inverter_product_output_voltage, set_inverter_product_output_voltage ] = React.useState("120/240");
  const [ inverter_product_output_frequency, set_inverter_product_output_frequency ] = React.useState(60);
  const [ inverter_product_max_input_current, set_inverter_product_max_input_current ] = React.useState(720);
  const [ inverter_product_max_output_current, set_inverter_product_max_output_current ] = React.useState(140);

  const [ editContactModel, setEditContactModel ] = React.useState(false);
  const [ viewContactModel, setViewContactModel ] = React.useState(false);
  const [ addContactModel, setAddContactModel ] = React.useState(false);

  const [ loading, setLoading ] = React.useState(false);

  const [ contactLoading, setContactLoading ] = React.useState(false);

  const cancelButtonRef = React.useRef(null);
  const navigate        = useNavigate();

  const user            = useSelector((state) => state.user.profile);

  // const [isActive, setActive] = React.useState(true)
  // const handleButtonClick = React.useCallback(() => {
  //   setActive(value => !value);
  // }, [])

  React.useEffect(() => {
    loadContacts();
  }, [user, page]);

  const loadContacts = () => {
    setContactLoading(true);
    fetch(`${Config.API.URL}/products/inverter-products?page=${page}&sort_direction=ASC`, { //sort_by=first_name&
      method: "GET",
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
    }).then((res) => {
      setContactLoading(false);
      // if 401 error (unauthenticated user, then log user out)
      if (res.status === 401) {
        console.log("401 Error: Unauthenticated");

        localStorage.removeItem("user");
        navigate("/");
      }
      return res;
    }).then((res) => res.json()).then(async (res) => {
      // console.log('res', res);
      setContactLoading(false);
      if (res.status) {
        setContacts(res.data.data);
        setLastPage(res.data.last_page);
        setCurrentPage(res.data.current_page);
      } else {
        swal("Oh no!", res.message, "error");
      }
    }).catch((error) => {
      setContactLoading(false);
      console.log("Error: ", error);

      swal("Oh no!", "An error occured!!! while connecting to server. Please try again", "error");
    });
  };

  const _onDeleteProduct = (product) => {
    // console.log('product', product);
    // return false;
    swal({
      title: `Are you sure?`,
      text: `You want to delete "${product.inverter_product_name}"? because once deleted, you will not be able to recover this product!`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(`${Config.API.URL}/products/inverter-products/${product.id}`, {
          method: "DELETE",
          headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        })
          .then((res) => {
            // if 401 error (unauthenticated user, then log user out)
            if (res.status === 401) {
              console.log("401 Error: Unauthenticated");
              localStorage.removeItem("user");
              navigate("/");
            }
            return res;
          })
          .then((res) => res.json())
          .then(async (res) => {
            // if request is succesful, alert user that project has been cloned
            if (res.status) {
              let index = contacts.findIndex((x) => x.id === product.id);
              let data  = [ ...contacts ];

              data.splice(index, 1);
              setContacts(data);

              swal( `The "${product.inverter_product_name}" product has been successfully deleted!`, { icon: "success" } );
            } else {
              swal("Oh no!", res.message, "error");
            }
          })
          .catch((error) => {
            console.log("Error: ", error);

            swal("Oh no!", "An error occured!!! while connecting to server. Please try again", "error");
          });
      }
    });
  };
  const _onEditProduct = (product) => {
    setContact(product);

    setEditContactModel(true);

    set_inverter_product_name(product.inverter_product_name ? product.inverter_product_name : "");
    set_inverter_product_manufacturer(product.inverter_product_manufacturer ? product.inverter_product_manufacturer : "");
    set_inverter_product_part_number(product.inverter_product_part_number ? product.inverter_product_part_number : "");
    set_inverter_product_certifications(product.inverter_product_certifications ? product.inverter_product_certifications : "");

    set_inverter_product_unit_capacity(product.inverter_product_unit_capacity ? product.inverter_product_unit_capacity : "");
    set_inverter_product_unit_cost(product.inverter_product_unit_cost ? product.inverter_product_unit_cost : "");
    set_inverter_product_notes(product.inverter_product_notes ? product.inverter_product_notes : "");
    set_inverter_product_model(product.inverter_product_model ? product.inverter_product_model : "");
    set_inverter_product_output_power(product.inverter_product_output_power ? product.inverter_product_output_power : "");
    set_inverter_product_output_voltage(product.inverter_product_output_voltage ? product.inverter_product_output_voltage : "");
    set_inverter_product_output_frequency(product.inverter_product_output_frequency ? product.inverter_product_output_frequency : "");
    set_inverter_product_max_input_current(product.inverter_product_max_input_current ? product.inverter_product_max_input_current : "");
    set_inverter_product_max_output_current(product.inverter_product_max_output_current ? product.inverter_product_max_output_current : "");
  };
  const _onViewProduct = (product) => {
    //setContact(product);

    navigate(`/preview/inverter/single/product/${product.id}`);

    // setViewContactModel(true);

    // set_inverter_product_name(product.inverter_product_name ? product.inverter_product_name : "");
    // set_inverter_product_manufacturer(product.inverter_product_manufacturer ? product.inverter_product_manufacturer : "");
    // set_inverter_product_part_number(product.inverter_product_part_number ? product.inverter_product_part_number : "");
    // set_inverter_product_certifications(product.inverter_product_certifications ? product.inverter_product_certifications : "");

    // set_inverter_product_unit_capacity(product.inverter_product_unit_capacity ? product.inverter_product_unit_capacity : "");
    // set_inverter_product_unit_cost(product.inverter_product_unit_cost ? product.inverter_product_unit_cost : "");
    // set_inverter_product_notes(product.inverter_product_notes ? product.inverter_product_notes : "");
    // set_inverter_product_model(product.inverter_product_model ? product.inverter_product_model : "");
    // set_inverter_product_output_power(product.inverter_product_output_power ? product.inverter_product_output_power : "");
    // set_inverter_product_output_voltage(product.inverter_product_output_voltage ? product.inverter_product_output_voltage : "");
    // set_inverter_product_output_frequency(product.inverter_product_output_frequency ? product.inverter_product_output_frequency : "");
    // set_inverter_product_max_input_current(product.inverter_product_max_input_current ? product.inverter_product_max_input_current : "");
    // set_inverter_product_max_output_current(product.inverter_product_max_output_current ? product.inverter_product_max_output_current : "");
  };
  const submitProduct = () => {
    if (inverter_product_name.length && inverter_product_manufacturer.length && inverter_product_part_number.length && inverter_product_certifications.length) {
      setLoading(true);
      const payload = {
        inverter_product_name,
        inverter_product_manufacturer,
        inverter_product_part_number,
        inverter_product_certifications,
        inverter_product_unit_capacity,
        inverter_product_unit_cost,
        inverter_product_notes,
        inverter_product_model,
        inverter_product_output_power,
        inverter_product_output_voltage,
        inverter_product_output_frequency,
        inverter_product_max_input_current,
        inverter_product_max_output_current,
      };

      fetch(`${Config.API.URL}/products/inverter-products/${contact?.id}`, {
        method: "PATCH",
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          setLoading(false);

          // if 401 error (unauthenticated user, then log user out)
          if (res.status === 401) {
            console.log("401 Error: Unauthenticated");
            localStorage.removeItem("user");
            navigate("/");
          }
          return res;
        })
        .then((res) => res.json())
        .then(async (res) => {
          setLoading(false);

          // if request is succesful, alert user that project has been cloned
          if (res.status) {
            setEditContactModel(false);

            let index   = contacts.findIndex((x) => x.id === contact.id);
            let data    = [ ...contacts ];

            data[index] = res.data;

            setContacts(data);
          } else {
            swal("Oh no!", res.message, "error");
          }
        }).catch((error) => {
          setLoading(false);

          console.log("Error: ", error);

          swal("Oh no!", "An error occured!!! while connecting to server. Please try again", "error");
        });
    } else {
      swal("Oh no!", "All fields with asterisk(*) are required", "error");
    }
  };

  const _onCreateProduct = (product) => {
    //setContact(product);

    setAddContactModel(true);

    set_inverter_product_name("");
    set_inverter_product_manufacturer("");
    set_inverter_product_part_number("");
    set_inverter_product_certifications("");

    set_inverter_product_unit_capacity("");
    set_inverter_product_unit_cost("");
    set_inverter_product_notes("");
    set_inverter_product_model("");
    set_inverter_product_output_power("");
    set_inverter_product_output_voltage("");
    set_inverter_product_output_frequency("");
    set_inverter_product_max_input_current("");
    set_inverter_product_max_output_current("");
  };
  const createProduct = () => {
    if (inverter_product_name.length && inverter_product_manufacturer.length && inverter_product_part_number.length && inverter_product_certifications.length) {
      setLoading(true);
      const payload = {
        inverter_product_name,
        inverter_product_manufacturer,
        inverter_product_part_number,
        inverter_product_certifications,
        inverter_product_unit_capacity,
        inverter_product_unit_cost,
        inverter_product_notes,
        inverter_product_model,
        inverter_product_output_power,
        inverter_product_output_voltage,
        inverter_product_output_frequency,
        inverter_product_max_input_current,
        inverter_product_max_output_current,
      };

      fetch(`${Config.API.URL}/products/inverter-products`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          setLoading(false);

          // if 401 error (unauthenticated user, then log user out)
          if (res.status === 401) {
            console.log("401 Error: Unauthenticated");
            localStorage.removeItem("user");
            navigate("/");
          }
          return res;
        })
        .then((res) => res.json())
        .then(async (res) => {
          setLoading(false);

          // if request is succesful, alert user that project has been cloned
          if (res.status) {
            setAddContactModel(false);

            // let index   = contacts.findIndex((x) => x.id === contact.id);
            let data = [ res.data, ...contacts ];

            // data[index] = res.data;

            setContacts(data);
          } else {
            swal("Oh no!", res.message, "error");
          }
        }).catch((error) => {
          setLoading(false);

          console.log("Error: ", error);

          swal("Oh no!", "An error occured!!! while connecting to server. Please try again", "error");
        });
    } else {
      swal("Oh no!", "All fields with asterisk(*) are required", "error");
    }
  };

  const _onSearchContacts = (keywords) => {
    if (keywords.length >= 3) {
      fetch(`${Config.API.URL}/contacts/search?keyword=${keywords}&page=1&limit=10`, {
        method: "GET",
        headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${user.token}` },
      }).then((res) => {
        // if 401 error (unauthenticated user, then log user out)
        if (res.status === 401) {
          console.log("401 Error: Unauthenticated");
          localStorage.removeItem("user");
          navigate("/");
        }
        return res;
      }).then((res) => res.json()).then(async (res) => {
        if (res.status) {
          const result = res.data;
          result.data ? setContacts(result.data) : setContacts(result);
          setLastPage(result.last_page);
          setCurrentPage(result.current_page);
        } else {
          swal("Oh no!", res.message, "error");
        }
      }).catch((error) => {
        console.log("Error: ", error);

        swal("Oh no!", "An error occured!!! while connecting to server. Please try again", "error" );
      });
    } else {
      if (!keywords.length) {
        loadContacts();
      }
    }
  };
  return (
    <>
      {/* <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
        <LoadingOverlay
          active={isActive}
          spinner
          text='Loading your content...'
        >
          <div style={{ height: '100vh', position: 'relative' }}>
          </div>
        </LoadingOverlay>
      </div> */}
      <div className="grid grid-cols-12  ">
        <div className=" lg:col-span-2">
          <Sidebardata />
        </div>
        <div className=" transition-none col-span-12 lg:col-span-12 mr-3  ">
          <div className=" w-[85%] sm:w-[95%] ml-auto ">
            <Header />
            <Hero productsTitle="Inverter Products" />
            { contactLoading ?
              <Loading />
            :
              <div className=" mt-10 bg-white rounded-[8px] p-4">
                <UniversalDataTable
                  table_label="Inverter Products"
                  header_format={[ 
                    { column: "inverter_product_name", label: "Product Name" }, 
                    { column: "inverter_product_manufacturer", label: "Product Manufacturer" }, 
                    { column: "inverter_product_part_number", label: "Product Part Number" }, 
                    { column: "inverter_product_certifications", label: "Product Certifications" }, 
                  ]}
                  data={contacts}
                  data_format={[
                    { column: "inverter_product_name", keys: ["inverter_product_name"] }, 
                    { column: "inverter_product_manufacturer", keys: ["inverter_product_manufacturer"] }, 
                    { column: "inverter_product_part_number", keys: ["inverter_product_part_number"] }, 
                    { column: "inverter_product_certifications", keys: ["inverter_product_certifications"], button: true }, 
                  ]}
                  columns_format={false}
                  setPage={setPage}
                  lastPage={lastPage}
                  currentPage={currentPage}
                  onCreateItem={_onCreateProduct }
                  onViewItem={_onViewProduct}
                  onDeleteItem={_onDeleteProduct}
                  onEditItem={_onEditProduct}
                  onSearchData={_onSearchContacts}
                />
              </div>
            }
          </div>
        </div>
      </div>

      <Transition.Root show={editContactModel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setEditContactModel}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Edit Product Information
                        </Dialog.Title>
                        <div className="mt-2" style={{ width: "100%" }}>
                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product name{" "}
                                <span className="text-primary">*</span>
                              </label>
                              
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_name(e.target.value)}
                                  value={inverter_product_name}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Manufacturer
                                <span className="text-primary">*</span>
                              </label>
        
                              <div className="mt-2">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_manufacturer(e.target.value)}
                                  value={inverter_product_manufacturer}
                                  rows="4"
                                  className="pr-2 pl-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Part Number
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_part_number(e.target.value)}
                                  value={inverter_product_part_number}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Certifications
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_certifications(e.target.value)}
                                  value={inverter_product_certifications}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Capacity
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_capacity(e.target.value)}
                                  value={inverter_product_unit_capacity}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Cost
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_cost(e.target.value)}
                                  value={inverter_product_unit_cost}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Notes
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_notes(e.target.value)}
                                  value={inverter_product_notes}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Model
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_model(e.target.value)}
                                  value={inverter_product_model}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Power
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_power(e.target.value)}
                                  value={inverter_product_output_power}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Voltage
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_voltage(e.target.value)}
                                  value={inverter_product_output_voltage}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Frequency
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_frequency(e.target.value)}
                                  value={inverter_product_output_frequency}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Input Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_input_current(e.target.value)}
                                  value={inverter_product_max_input_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Output Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_output_current(e.target.value)}
                                  value={inverter_product_max_output_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    {loading ? (
                      <button className=" inline-flex w-full justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto ">
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                        onClick={submitProduct}
                      >
                        Save
                      </button>
                    )}
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setEditContactModel(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={viewContactModel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setViewContactModel}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          View Product Information
                        </Dialog.Title>
                        <div className="mt-2" style={{ width: "100%" }}>
                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Name{" "}
                                <span className="text-primary">*</span>
                              </label>
                              
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_name(e.target.value)}
                                  value={inverter_product_name}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Manufacturer
                                <span className="text-primary">*</span>
                              </label>
        
                              <div className="mt-2">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_manufacturer(e.target.value)}
                                  value={inverter_product_manufacturer}
                                  rows="4"
                                  className="pr-2 pl-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Part Number
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_part_number(e.target.value)}
                                  value={inverter_product_part_number}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Certifications
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_certifications(e.target.value)}
                                  value={inverter_product_certifications}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Capacity
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_capacity(e.target.value)}
                                  value={inverter_product_unit_capacity}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Cost
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_cost(e.target.value)}
                                  value={inverter_product_unit_cost}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Notes
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_notes(e.target.value)}
                                  value={inverter_product_notes}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Model
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_model(e.target.value)}
                                  value={inverter_product_model}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Power
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_power(e.target.value)}
                                  value={inverter_product_output_power}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Voltage
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_voltage(e.target.value)}
                                  value={inverter_product_output_voltage}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Frequency
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_frequency(e.target.value)}
                                  value={inverter_product_output_frequency}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Input Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_input_current(e.target.value)}
                                  value={inverter_product_max_input_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Output Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  readOnly
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_output_current(e.target.value)}
                                  value={inverter_product_max_output_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setViewContactModel(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={addContactModel} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setAddContactModel}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:items-start">
                      <div className="mt-3 text-center sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Add Product Information
                        </Dialog.Title>
                        <div className="mt-2" style={{ width: "100%" }}>
                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product name{" "}
                                <span className="text-primary">*</span>
                              </label>
                              
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_name(e.target.value)}
                                  value={inverter_product_name}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Manufacturer
                                <span className="text-primary">*</span>
                              </label>
        
                              <div className="mt-2">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_manufacturer(e.target.value)}
                                  value={inverter_product_manufacturer}
                                  rows="4"
                                  className="pr-2 pl-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Part Number
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_part_number(e.target.value)}
                                  value={inverter_product_part_number}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Certifications
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_certifications(e.target.value)}
                                  value={inverter_product_certifications}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Capacity
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_capacity(e.target.value)}
                                  value={inverter_product_unit_capacity}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Unit Cost
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_unit_cost(e.target.value)}
                                  value={inverter_product_unit_cost}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Notes
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_notes(e.target.value)}
                                  value={inverter_product_notes}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Model
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_model(e.target.value)}
                                  value={inverter_product_model}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Power
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_power(e.target.value)}
                                  value={inverter_product_output_power}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Voltage
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_voltage(e.target.value)}
                                  value={inverter_product_output_voltage}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product Output Frequency
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_output_frequency(e.target.value)}
                                  value={inverter_product_output_frequency}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Input Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_input_current(e.target.value)}
                                  value={inverter_product_max_input_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                            <div className="col-span-full">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Product MAX Output Current
                                <span className="text-primary">*</span>
                              </label>
                              <div className="mt-0">
                                <input
                                  type="text"
                                  onChange={(e) => set_inverter_product_max_output_current(e.target.value)}
                                  value={inverter_product_max_output_current}
                                  className="p-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    {loading ? (
                      <button className=" inline-flex w-full justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto ">
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 sm:ml-3 sm:w-auto"
                        onClick={createProduct}
                      >
                        Save
                      </button>
                    )}
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => setAddContactModel(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}
